import { Claim } from '../api/claims';

/**
 * Finance claims: claim numbers starting FC, FM or CL followed by a digit
 * (e.g. FC100002.001).
 *
 * FC and FM claims came across from Proclaim, and the import kept each one's
 * original Proclaim claim ID (8 characters, e.g. RSL6295U) in
 * legacyMetadata.originalClaimId. CL claims are made in this system by the
 * credit-check import, so today they never have one -- and the drawer shows
 * nothing rather than borrowing the reference of the claim a CL was copied
 * from, which belongs to a different agreement.
 *
 * Other claims are left out on purpose: some CG claims hold a sign-up
 * system's record id in the same field, which is not a Proclaim reference.
 */
const FINANCE_CLAIM_ID = /^(FC|FM|CL)\d/i;

/** Whether a claim is an FC/FM/CL finance claim. */
export function isFinanceClaim(claim?: Pick<Claim, 'id'> | null): boolean {
  return FINANCE_CLAIM_ID.test((claim?.id || '').trim());
}

/** The claim's original Proclaim claim ID, or null if it doesn't have one. */
export function getProclaimClaimReference(
  claim?: Pick<Claim, 'id' | 'legacyMetadata'> | null,
): string | null {
  if (!claim || !isFinanceClaim(claim)) {
    return null;
  }
  const value = claim.legacyMetadata?.originalClaimId;
  if (typeof value !== 'string') {
    return null;
  }
  const trimmed = value.trim();
  return trimmed || null;
}
